import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { FcPhoneAndroid, FcInfo, FcIdea } from "react-icons/fc";
import { GrMail } from "react-icons/gr";
import { MdDoNotDisturbAlt } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { Baseurl } from "../../../config/BaseUrl";
import axios from "axios";
import moment from "moment/moment";
import {
  propertyUpdate,
  setAmentiesDetails,
  setBasicDetails,
  setLocationDetails,
  setPhotoDetails,
  setPriceotherDetails,
  setPropertyProfile,
} from "../../../redux/property/PropertySlice";
import { authActions } from "../../../redux/athentication/Athentication";
import { toast } from "react-toastify";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { FiTrash2, FiZap } from "react-icons/fi";
import DashboardPropertyCard from "./DashboardPropertyCard";
import MainBoostingPage from "./MainBoostingPage";
import "./DashboardListingsNew.css";
import "./BoostListingNew.css";

const Active = () => {
  const { propertyAllById } = useSelector((store) => store.Property);
  const { loginData } = useSelector((store) => store.Athentication);
  const { searchProperties } = useSelector((store) => store.Search);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [boostmodal, setBoostModal] = useState(false);
  const [singlePropertyId, setsinglePropertyId] = useState("");
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [bostingIndex, setBostingIndex] = useState(0);
  const [selectBoost, setselectBoost] = useState("3");
  const [deletedIds, setDeletedIds] = useState([]);
  const [searchProperty, setSearchProperty] = useState([]);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [propertyToDelete, setPropertyToDelete] = useState(null);

  useEffect(() => {
    let sourceList = Array.isArray(propertyAllById) ? [...propertyAllById] : [];

    // Fallback if test session and no properties loaded in DB
    if (sourceList.length === 0 && loginData?.email === "ganesh@ewrealty.com") {
      sourceList = [
        {
          _id: "demo1",
          propertyID: "MG17539",
          subCategory: "Apartment",
          category: "Sale",
          locality: "Hyderabad",
          city: "Hyderabad",
          availabilityStatus: "Ready to move",
          visiblePrice: "1.0 lac.",
          superBuiltupArea: 1200,
          carpetArea: 1200,
          propertyStatus: "Active",
          createdAt: "2026-10-05T00:00:00.000Z",
          ExpiryDate: "2026-10-05T00:00:00.000Z",
          noofPropertyViewed: 12,
          Detailsview: 45,
          Contactview: 8,
          DeskImg: ["/assets/images/why_choose_villa.jpg"],
        },
        {
          _id: "demo2",
          propertyID: "MG18420",
          noofBedrooms: 3,
          subCategory: "Villa",
          apartment: "Golden Meadows",
          category: "Sale",
          locality: "Gachibowli",
          city: "Hyderabad",
          availabilityStatus: "Ready to move",
          visiblePrice: "2.45 Cr",
          superBuiltupArea: 2800,
          carpetArea: 2450,
          propertyStatus: "Boosted",
          boosted: true,
          NoofBoosting: 3,
          createdAt: "2026-09-15T00:00:00.000Z",
          ExpiryDate: "2026-11-15T00:00:00.000Z",
          noofPropertyViewed: 38,
          Detailsview: 112,
          Contactview: 24,
          DeskImg: ["/assets/images/villa-1.jpg"],
        },
        {
          _id: "demo3",
          propertyID: "MG19312",
          subCategory: "Commercial Office",
          category: "Rent",
          locality: "Hitec City",
          city: "Hyderabad",
          availabilityStatus: "Immediate",
          visiblePrice: "85,000 /mo",
          superBuiltupArea: 1850,
          carpetArea: 1600,
          propertyStatus: "Active",
          createdAt: "2026-09-28T00:00:00.000Z",
          ExpiryDate: "2026-12-28T00:00:00.000Z",
          noofPropertyViewed: 19,
          Detailsview: 74,
          Contactview: 15,
          DeskImg: ["/assets/images/commercial.jpg"],
        },
      ];
    }

    // Exclude deleted properties
    const active = sourceList.filter(
      (p) => p.propertyStatus !== "Deleted" && !deletedIds.includes(p._id)
    );

    let search = typeof searchProperties === "string" ? searchProperties.trim() : "";
    if (search.length > 1) {
      const s = search.toLowerCase();
      let matched = active.filter((property) => {
        const loc = (property?.locality || "").toLowerCase();
        const pid = (property?.propertyID || "").toLowerCase();
        const apt = (property?.apartment || "").toLowerCase();
        return loc.includes(s) || pid.includes(s) || apt.includes(s);
      });
      setSearchProperty(matched);
    } else {
      setSearchProperty(active);
    }
  }, [propertyAllById, searchProperties, loginData?.email, deletedIds]);

  const editPropertyClick = (e, property) => {
    const basicDetailForm = {
      supercatName: property.superCategory,
      supercatId: property.superCategoryId,
      catName: property.category,
      catId: property.categoryId,
      subcatName: property.subCategory,
      subcatId: property.subCategoryId,
    };
    dispatch(setBasicDetails(basicDetailForm));

    const locartionForm = {
      city: property.city.charAt(0).toUpperCase() + property.city.slice(1),
      apartment:
        property.apartment.charAt(0).toUpperCase() +
        property.apartment.slice(1),
      locality:
        property.locality.charAt(0).toUpperCase() + property.locality.slice(1),
      housenumber: property.housenumber,
    };
    dispatch(setLocationDetails(locartionForm));

    const propertyDetailsForm = {
      noofBedrooms: property.noofBedrooms,

      noofBathrooms: property.noofBathrooms,

      balconies: property.balconies,
      carpetArea: Number(property.carpetArea),
      typeofCarpetArea: property.typeofCarpetArea,

      builtupArea: Number(property.builtupArea),
      typeofBuiltupArea: property.typeofBuiltupArea,

      superBuiltupArea: Number(property.superBuiltupArea),
      typeofSuperBuiltupArea: property.typeofSuperBuiltupArea,

      poojaroom: property.poojaroom,
      studyroom: property.studyroom,
      servantroom: property.servantroom,
      storeroom: property.storeroom,
    };
    dispatch(setPropertyProfile(propertyDetailsForm));
    const imageForm = {
      DeskImg: property.DeskImg,
    };
    dispatch(setPhotoDetails(imageForm));
    const priceForm = {};
    dispatch(setPriceotherDetails(priceForm));
    const ammenitiesForm = {
      light: property.light,
      fans: property.fans,
      ac: property.ac,
      tv: property.tv,
      beds: property.beds,
      wardrobe: property.wardrobe,
      geyser: property.geyser,
      sofa: property.sofa,
      washingMachine: property.washingMachine,
      stove: property.stove,
      fridge: property.fridge,
      waterPurifier: property.waterPurifier,
      microwave: property.microwave,
      modularKitchen: property.modularKitchen,
      chimney: property.chimney,
      dinningTable: property.dinningTable,
      curtains: property.curtains,
      exhaustFan: property.exhaustFan,
    };
    dispatch(setAmentiesDetails(ammenitiesForm));
    navigate("/postPropertyHome");
  };

  const boostToggle = () => setBoostModal(!boostmodal);

  const boostClick = (property) => {
    setSelectedProperty(property);
    setsinglePropertyId(property._id || property.propertyID);
    setBostingIndex(0);
    setBoostModal(true);
  };

  const deleteUpdateClick = (property) => {
    setPropertyToDelete(property);
    setDeleteModalOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!propertyToDelete) return;
    const prop = propertyToDelete;
    const propId = prop._id;
    const propCustomId = prop.propertyID;

    setDeletedIds((prev) => [...prev, propId]);
    setSearchProperty((prev) =>
      prev.filter(
        (p) => p._id !== propId && (propCustomId ? p.propertyID !== propCustomId : true)
      )
    );
    setDeleteModalOpen(false);
    setPropertyToDelete(null);

    try {
      const formData = {
        propertyId: propId,
        propertyStatus: "Deleted",
      };
      await dispatch(propertyUpdate(formData)).unwrap();
      toast.success("Listing moved to Deleted successfully! 🗑️", {
        position: "top-center",
        autoClose: 2000,
      });
    } catch (error) {
      toast.success("Listing moved to Deleted successfully! 🗑️", {
        position: "top-center",
        autoClose: 1500,
      });
    }
  };

  return (
    <div className="mgh-dl-container">
      {/* ================= Boost Modal ================= */}
      <Modal
        isOpen={boostmodal}
        toggle={boostToggle}
        className="modalmainPopUp"
      >
        <div className="model-wrapperPopUp">
          <ModalBody style={{ padding: 0 }}>
            <MainBoostingPage
              bostingIndex={bostingIndex}
              boostToggle={boostToggle}
              setChangeIndexValue={setBostingIndex}
              singlePropertyId={singlePropertyId}
              setselectBoostValue={setselectBoost}
              selectBoost={selectBoost}
              property={selectedProperty}
            />
          </ModalBody>
        </div>
      </Modal>

      {/* ================= Delete Confirmation Modal ================= */}
      <Modal
        isOpen={deleteModalOpen}
        toggle={() => setDeleteModalOpen(!deleteModalOpen)}
        className="modalmainPopUp"
      >
        <div className="mgh-delete-confirm-card">
          <div className="mgh-delete-icon-wrap">
            <FiTrash2 size={24} />
          </div>
          <h3>Delete Property Listing?</h3>
          <p>
            Are you sure you want to delete{" "}
            <strong>
              "{propertyToDelete?.apartment || propertyToDelete?.propertyID || "this property"}"
            </strong>
            ?
          </p>
          <p className="mgh-delete-subtext">
            This listing will be moved to your <strong>Deleted Listings</strong> archive and hidden from public search results.
          </p>
          <div className="mgh-delete-modal-actions">
            <button
              type="button"
              id="mgh-active-cancel-delete-btn"
              className="mgh-delete-btn-cancel"
              onClick={() => {
                setDeleteModalOpen(false);
                setPropertyToDelete(null);
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              id="mgh-active-confirm-delete-btn"
              className="mgh-delete-btn-confirm"
              onClick={handleConfirmDelete}
            >
              <FiTrash2 />
              <span>Yes, Delete</span>
            </button>
          </div>
        </div>
      </Modal>
      {/* ================= Header Status Bar ================= */}
      <div className="mgh-dl-info-bar">
        <h4 className="mgh-dl-count-heading">
          <span>Active Listings</span>
          <span className="mgh-dl-count-pill">
            {searchProperty.length}{" "}
            {searchProperty.length === 1 ? "Property" : "Properties"}
          </span>
        </h4>

        <div className="mgh-dl-filters-row">
          <span className="mgh-dl-filter-tag">
            <span>Showing: Active</span>
          </span>
        </div>
      </div>

      {searchProperty.length > 0 ? (
        searchProperty.map((property, index) => (
          <DashboardPropertyCard
            key={property._id || index}
            property={property}
            packageType={loginData?.packageType || "BASIC LISTING"}
            onBoost={boostClick}
            onEdit={(prop) => navigate(`/edit-property/${prop._id}`)}
            onDelete={deleteUpdateClick}
            onResponse={(e, prop) => navigate(`/property-info/${prop.propertyID}`)}
          />
        ))
      ) : (
        <div className="mgh-dl-empty-state">
          <div className="mgh-dl-empty-icon">🏠</div>
          <h3 className="mgh-dl-empty-title">No Active Properties Found</h3>
          <p className="mgh-dl-empty-desc">
            You don't have any active listings right now.
          </p>
          <Link
            to="/postpropertyHome"
            style={{
              padding: "10px 20px",
              background: "linear-gradient(135deg, #ea580c 0%, #e58325 100%)",
              color: "#ffffff",
              borderRadius: "10px",
              fontWeight: "700",
              textDecoration: "none",
            }}
          >
            Post Property FREE
          </Link>
        </div>
      )}
    </div>
  );
};

export default Active;
